module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Black.d871d604.woff2";